import React from 'react';
import { BadgeCheckIcon } from 'lucide-react';
import { BrandButton } from './BrandButton';
export function Guarantee() {
  return <section id="guarantee" aria-labelledby="guarantee-title" className="border-b border-white/5 bg-ink-900" data-id="element-105" data-mp="1o33tsfx1zqh8">
      <div className="mx-auto max-w-content px-5 py-20 sm:px-8 sm:py-24" data-id="element-106" data-mp="22126zhzn1gv5">
        <div className="rounded-2xl border-2 border-brand bg-ink-800 p-8 sm:p-12" data-id="element-107" data-mp="1x54ph8cn24gs">
          <span className="inline-flex items-center gap-2 rounded-full border border-brand/40 bg-brand/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.14em] text-brand" data-id="element-108" data-mp="19fipiiofzl7q">
            <BadgeCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-109" data-mp="1j4u24fajf80d" />
            Guarantee
          </span>
          <h2 id="guarantee-title" className="mt-6 max-w-2xl font-display text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-110" data-mp="1ecsooq1mvb8r">
            The go-live guarantee, in writing.
          </h2>
          <p className="mt-6 max-w-3xl text-base leading-relaxed text-white/75 sm:text-lg" data-id="element-111" data-mp="lnc0y5oykiiv">
            Once your system is live, every missed call gets answered live by AI voice, and
            every form, message, and DM gets a response in under 60 seconds. If we do not
            book at least 20% of your qualified inbound leads into appointments in your
            first 30 days, that month is free. You keep every appointment either way.
            Nobody else in this category puts a number in writing. We do.
          </p>
          <div className="mt-9 flex flex-col items-start gap-5 sm:flex-row sm:items-center" data-id="element-112" data-mp="az8mlmi5u66m">
            <BrandButton label="Book the Audit" size="lg" withArrow data-id="element-113" data-mp="f0u2zhtwl2lk" />
            <p className="max-w-sm text-xs leading-relaxed text-white/40" data-id="element-114" data-mp="f3on18908leg">
              Guarantee window starts at completed onboarding. Typical onboarding is under
              7 business days once we have access.
            </p>
          </div>
        </div>
      </div>
    </section>;
}